var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject } from "rxjs";
import { JsonApiService } from "@app/core/services/json-api.service";
var defaultUser = {
    username: "Guest"
};
var UserService = /** @class */ (function () {
    function UserService(jsonApiService) {
        this.jsonApiService = jsonApiService;
        this.user$ = new BehaviorSubject(__assign({}, defaultUser));
        this.jsonApiService.fetch("/user/login-info.json").subscribe(this.user$);
    }
    UserService.prototype.logout = function () {
        this.user$.next(__assign({}, defaultUser));
    };
    return UserService;
}());
export { UserService };
